import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ListLayout1 } from '@components/list/components/list-layout-1/model';
import { ResponsiveService } from '@services/responsive';
import { TitleComponent } from '@shared/components/title';
import { Title } from '@shared/components/title/model';
import { SplitArrayByPipe } from '@shared/pipes';

@Component({
  selector: 'app-list-layout-1',
  imports: [TitleComponent, RouterLink, SplitArrayByPipe],
  templateUrl: './list-layout-1.component.html',
  styleUrl: './list-layout-1.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListLayout1Component implements OnInit {
  readonly data = input.required<ListLayout1>();
  readonly breakpoints = inject(ResponsiveService).breakpoints;
  title = signal<Title>(null!);
  items = signal<
    {
      title: Title | undefined;
      items: { label: string; url: string }[];
    }[]
  >(null!);

  ngOnInit(): void {
    if (this.data().title) {
      this.title.set({
        level: 'H2',
        size: {
          mobile: 'H2',
          desktop: 'H3',
        },
        text: this.data().title,
        color: 'BLACK',
        align: {
          mobile: 'LEFT',
          desktop: 'LEFT',
        },
      });
    }
    this.items.set(
      this.data().lists.map((item) => ({
        title: item.title
          ? {
              level: 'SPAN',
              size: {
                mobile: 'H5',
                desktop: 'H5',
                custom: {
                  mobile: '2rem',
                  desktop: '2.4rem',
                },
              },
              weight: 700,
              text: item.title,
              color: 'BLACK',
              align: {
                mobile: 'LEFT',
                desktop: 'LEFT',
              },
            }
          : undefined,
        items: item.items,
      }))
    );
  }
}
